import React, { useState } from "react";
import MapView from "./MapView";
import { siigsolLegends } from "./legendData";

// --- Légende BDPPPA ---
function LegendBDPPPAHorizontal() {
  const legendItems = [
    { color: "#ef3199", label: "Autres" },
    { color: "#2db3df", label: "Avoine" },
    { color: "#6fdebd", label: "Blé, triticale, épeautre" },
    { color: "#77d486", label: "CMA-Fruits" },
    { color: "#da5759", label: "CMA-Légumes divers" },
    { color: "#2bd3d0", label: "CMA-Multiples" },
    { color: "#46ca35", label: "CMA-Racines" },
    { color: "#926cd8", label: "CMA-Vivaces" },
    { color: "#c6d14a", label: "Foin" },
    { color: "#e20dbf", label: "Inconnu" },
    { color: "#dc416d", label: "Légumes de transformation" },
    { color: "#cb4c1d", label: "Maïs fourrager" },
    { color: "#5673e5", label: "Maïs-grain" },
    { color: "#caa478", label: "Multiples" },
    { color: "#5994d3", label: "Orge" },
    { color: "#ade589", label: "Petits fruits" },
    { color: "#665cd9", label: "Pommes" },
    { color: "#cd6ed8", label: "Pommes de terre" },
    { color: "#decc84", label: "Protéagineuses" },
    { color: "#badc7a", label: "Seigle" },
    { color: "#9923dd", label: "Soya" },
    { color: "#57ce8b", label: "DESGROPRO" }
  ];
  return (
    <div style={{
      width: "96%",
      margin: "0em auto 0",
      background: "#2c3929",
      borderRadius: "10px",
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      gap: "1em",
      alignItems: "center",
      padding: "0.9em 0.8em",
      boxShadow: "0 2px 6px rgba(30,30,30,0.1)",
      overflowX: "auto",
      overflowY: "hidden",
      zIndex: 9999,
      position: "relative",
      minHeight: "90px",
      maxHeight: "120px",
      flex: "0 0 auto"
    }}>
      <span style={{
        fontWeight: "bold",
        color: "#fff",
        marginRight: "0.8em",
        minWidth: "90px",
        fontSize: "0.78em",
        letterSpacing: "0.5px"
      }}>
        Légende BDPPPA
      </span>
      {legendItems.map(item => (
        <span key={item.label} style={{
          display: "flex",
          alignItems: "center",
          gap: "0.22em",
          color: "#fff",
          fontSize: "0.68em"
        }}>
          <span style={{
            width: 14,
            height: 14,
            borderRadius: "2px",
            background: item.color,
            border: "1px solid #fff",
            display: "inline-block"
          }} />
          {item.label}
        </span>
      ))}
    </div>
  );
}

// --- Légende SIIGSOL ---
function LegendSIIGSOLHorizontal({ activeLayer }) {
  const legendData = siigsolLegends[activeLayer];
  if (!legendData) return null;

  // Supporte l'ancienne structure (array) et la nouvelle (object avec title et items)
  const items = Array.isArray(legendData) ? legendData : legendData.items;
  const title = legendData.title || "Légende SIIGSOL";

  return (
    <div style={{
      width: "96%",
      margin: "0em auto 0",
      background: "#2c3929",
      borderRadius: "10px",
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      gap: "1em",
      alignItems: "center",
      padding: "0.9em 0.8em",
      boxShadow: "0 2px 6px rgba(30,30,30,0.1)",
      overflowX: "auto",
      overflowY: "hidden",
      zIndex: 9999,
      position: "relative",
      minHeight: "90px",
      maxHeight: "120px",
      flex: "0 0 auto"
    }}>
      <span style={{
        fontWeight: "bold",
        color: "#fff",
        marginRight: "0.8em",
        minWidth: "90px",
        fontSize: "0.78em",
        letterSpacing: "0.5px"
      }}>
        {title}
      </span>
      {items.map(item => (
        <span key={item.label} style={{
          display: "flex",
          alignItems: "center",
          gap: "0.22em",
          color: "#fff",
          fontSize: "0.68em"
        }}>
          <span style={{
            width: 14,
            height: 14,
            borderRadius: "2px",
            background: item.color,
            border: "1px solid #fff",
            display: "inline-block"
          }} />
          {item.label}
        </span>
      ))}
    </div>
  );
}

// --- Légende IAC ---
function LegendIACHorizontal() {
  const iacClasses = [
    { code: 10, label: "Nuages", color: "rgb(0,0,0)" },
    { code: 20, label: "Eau", color: "rgb(51,51,255)" },
    { code: 30, label: "Sols nus/terres stériles", color: "rgb(153,102,102)" },
    { code: 34, label: "Milieu urbain/bâti", color: "rgb(204,102,153)" },
    { code: 35, label: "Serres", color: "rgb(225,225,225)" },
    { code: 50, label: "Arbustaie", color: "rgb(255,255,0)" },
    { code: 60, label: "Incendie de forêt / zone brûlée", color: "rgb(102,102,102)" },
    { code: 80, label: "Terres humides", color: "rgb(153,51,153)" },
    { code: 85, label: "Tourbière exploitée", color: "rgb(80,27,80)" },
    { code: 110, label: "Prairies", color: "rgb(204,204,0)" },
    { code: 120, label: "Agriculture (indifférenciée)", color: "rgb(204,102,0)" },
    { code: 122, label: "Pâturage/Cultures fourragères", color: "rgb(255,204,51)" },
    { code: 130, label: "Trop humide pour l’ensemencement", color: "rgb(120,153,246)" },
    { code: 131, label: "Jachère", color: "rgb(255,153,0)" },
    { code: 132, label: "Céréales", color: "rgb(102,0,0)" },
    { code: 133, label: "Orge", color: "rgb(218,227,29)" },
    { code: 134, label: "Autres céréales", color: "rgb(153,204,0)" },
    { code: 135, label: "Millet", color: "rgb(210,219,37)" },
    { code: 136, label: "Avoine", color: "rgb(209,213,43)" },
    { code: 137, label: "Seigle", color: "rgb(202,206,50)" },
    { code: 138, label: "Épeautre", color: "rgb(195,198,58)" },
    { code: 139, label: "Triticale", color: "rgb(185,188,68)" },
    { code: 140, label: "Blé", color: "rgb(167,179,77)" },
    { code: 141, label: "Panic érigé", color: "rgb(185,198,78)" },
    { code: 142, label: "Sorgho", color: "rgb(153,153,0)" },
    { code: 143, label: "Quinoa", color: "rgb(233,226,177)" },
    { code: 145, label: "Blé d’hiver", color: "rgb(128,161,105)" },
    { code: 146, label: "Blé de printemps", color: "rgb(146,165,91)" },
    { code: 147, label: "Maïs", color: "rgb(255,255,126)" },
    { code: 148, label: "Tabac", color: "rgb(152,136,124)" },
    { code: 149, label: "Ginseng", color: "rgb(121,155,147)" },
    { code: 150, label: "Oléagineux", color: "rgb(94,162,99)" },
    { code: 151, label: "Bourrache", color: "rgb(82,174,119)" },
    { code: 152, label: "Caméline", color: "rgb(65,191,122)" },
    { code: 153, label: "Canola/Colza", color: "rgb(214,255,145)" },
    { code: 154, label: "Lin", color: "rgb(140,140,255)" },
    { code: 155, label: "Moutarde", color: "rgb(214,204,0)" },
    { code: 156, label: "Carthame", color: "rgb(255,127,0)" },
    { code: 157, label: "Tournesol", color: "rgb(49,84,145)" },
    { code: 158, label: "Soya", color: "rgb(204,153,51)" },
    { code: 160, label: "Légumineuses", color: "rgb(137,110,67)" },
    { code: 161, label: "Autres Légumineuses", color: "rgb(153,102,51)" },
    { code: 162, label: "Pois", color: "rgb(143,108,61)" },
    { code: 163, label: "Pois Chiche", color: "rgb(182,134,61)" },
    { code: 164, label: "Haricots", color: "rgb(130,101,105)" },
    { code: 168, label: "Féveroles", color: "rgb(163,144,105)" },
    { code: 174, label: "Lentilles", color: "rgb(184,89,0)" },
    { code: 175, label: "Légumes", color: "rgb(183,75,21)" },
    { code: 176, label: "Tomates", color: "rgb(255,138,138)" },
    { code: 177, label: "Pomme de terre", color: "rgb(255,204,204)" },
    { code: 178, label: "Betterave à sucre", color: "rgb(111,85,202)" },
    { code: 179, label: "Autres légumes", color: "rgb(255,204,255)" },
    { code: 180, label: "Fruits", color: "rgb(220,84,36)" },
    { code: 181, label: "Petits fruits", color: "rgb(208,90,48)" },
    { code: 182, label: "Bleuet", color: "rgb(210,0,0)" },
    { code: 183, label: "Canneberge", color: "rgb(204,0,0)" },
    { code: 185, label: "Autres baie", color: "rgb(220,50,0)" },
    { code: 188, label: "Vergers", color: "rgb(255,102,102)" },
    { code: 189, label: "Autres fruits", color: "rgb(197,69,69)" },
    { code: 190, label: "Vignobles", color: "rgb(116,66,189)" },
    { code: 191, label: "Houblon", color: "rgb(255,204,153)" },
    { code: 192, label: "Gazon en plaques", color: "rgb(181,251,5)" },
    { code: 193, label: "Fines herbes", color: "rgb(204,255,5)" },
    { code: 194, label: "Pépinière", color: "rgb(7,249,140)" },
    { code: 195, label: "Sarrasin", color: "rgb(0,255,204)" },
    { code: 196, label: "Graines à canaris", color: "rgb(204,51,204)" },
    { code: 197, label: "Chanvre", color: "rgb(142,118,144)" },
    { code: 198, label: "Vesce", color: "rgb(177,149,79)" },
    { code: 199, label: "Autres cultures", color: "rgb(116,154,102)" },
    { code: 200, label: "Forêt (indifférenciée)", color: "rgb(0,153,0)" },
    { code: 210, label: "Forêt de conifères", color: "rgb(0,102,0)" },
    { code: 220, label: "Forêt de feuillus", color: "rgb(0,204,0)" },
    { code: 230, label: "Forêt mixte", color: "rgb(204,153,0)" }
  ];
  return (
    <div style={{
      width: "96%",
      margin: "0em auto 0",
      background: "#2c3929",
      borderRadius: "10px",
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      gap: "1em",
      alignItems: "center",
      padding: "0.9em 0.8em",
      boxShadow: "0 2px 6px rgba(30,30,30,0.1)",
      overflowX: "auto",
      overflowY: "hidden",
      zIndex: 9999,
      position: "relative",
      minHeight: "90px",
      maxHeight: "120px",
      flex: "0 0 auto"
    }}>
      <span style={{
        fontWeight: "bold",
        color: "#fff",
        marginRight: "0.8em",
        minWidth: "90px",
        fontSize: "0.78em",
        letterSpacing: "0.5px"
      }}>
        Légende IAC
      </span>
      {iacClasses.map(item => (
        <span key={item.label} style={{
          display: "flex",
          alignItems: "center",
          gap: "0.22em",
          color: "#fff",
          fontSize: "0.68em"
        }}>
          <span style={{
            width: 14,
            height: 14,
            borderRadius: "2px",
            background: item.color,
            border: "1px solid #fff",
            display: "inline-block"
          }} />
          {item.label}
        </span>
      ))}
    </div>
  );
}

// --- Tabs / couches ---
const tabs = [
  { key: "Carte interactive", label: "Carte interactive" },
  { key: "Données de sol", label: "Données de sol" },
  { key: "Données météo", label: "Données météo" },
  { key: "Données agricoles", label: "Données agricoles" }
];

const layersByTab = {
  "Carte interactive": [
    "Projet_MOS_Essai:Couverture_pedo_2022_Montere",
    "Projet_MOS_Essai:bdppa_montere",
    "Projet_MOS_Essai:Limite-montere",
    "Projet_MOS_Essai:Limites-MRC-Montere"
  ],
  "Données de sol": [
    "Projet_MOS_Essai:SIIGSOL_Argile_MRC_MOS",
    "Projet_MOS_Essai:SIIGSOL_CEC_MRC_MOS",
    "Projet_MOS_Essai:SIIGSOL_COrg_MRC_MOS",
    "Projet_MOS_Essai:SIIGSOL_Limon_MRC_MOS",
    "Projet_MOS_Essai:SIIGSOL_Sable_MRC_MOS",
    "Projet_MOS_Essai:SIIGSOL_pH_MRC_MOS",
    "Projet_MOS_Essai:Zone_specifiq"
  ],
  "Données météo": [
    "Projet_MOS_Essai:meteo_data",
    "Projet_MOS_Essai:Limite-montere"
  ],
  "Données agricoles": [
    "Projet_MOS_Essai:BDPPAD_2015_MRC_MOS",
    "Projet_MOS_Essai:BDPPAD_2016_MRC_MOS",
    "Projet_MOS_Essai:BDPPAD_2017_MRC_MOS",
    "Projet_MOS_Essai:BDPPAD_2018_MRC_MOS",
    "Projet_MOS_Essai:BDPPAD_2019_MRC_MOS",
    "Projet_MOS_Essai:BDPPAD_2020_MRC_MOS",
    "Projet_MOS_Essai:BDPPAD_2021_MRC_MOS",
    "Projet_MOS_Essai:BDPPAD_2022_MRC_MOS",
    "Projet_MOS_Essai:BDPPAD_2023_MRC_MOS",
    "Projet_MOS_Essai:BDPPAD_2024_MRC_MOS",
    "Projet_MOS_Essai:IAC-2015_MRC",
    "Projet_MOS_Essai:IAC-2016_MRC",
    "Projet_MOS_Essai:IAC-2017_MRC",
    "Projet_MOS_Essai:IAC-2018_MRC",
    "Projet_MOS_Essai:IAC-2019_MRC",
    "Projet_MOS_Essai:IAC-2020_MRC",
    "Projet_MOS_Essai:IAC-2021_MRC",
    "Projet_MOS_Essai:IAC-2022_MRC",
    "Projet_MOS_Essai:IAC-2023_MRC",
    "Projet_MOS_Essai:IAC-2024_MRC"
  ]
};

// --- Logique de légende à afficher ---
function getLegendTypeForLayers(visibleLayers, activeTab) {
  // Priorité : BDPPPA > IAC > SIIGSOL
  if (visibleLayers.some(l => l.startsWith("Projet_MOS_Essai:BDPPAD_") || l === "Projet_MOS_Essai:bdppa_montere")) {
    return "BDPPPA";
  }
  if (visibleLayers.some(l => l.startsWith("Projet_MOS_Essai:IAC-"))) {
    return "IAC";
  }
  if (visibleLayers.some(l => l.startsWith("Projet_MOS_Essai:SIIGSOL_"))) {
    return "SIIGSOL";
  }
  // Pas de barre pour les couches météo
  return null;
}

// --- Composant principal ---
export default function AccederDonnees({ onNavigate }) {
  const [activeTab, setActiveTab] = useState(tabs[0].key);
  const [activeLayer, setActiveLayer] = useState(layersByTab[tabs[0].key][0]);
  const [visibleLayers, setVisibleLayers] = useState([layersByTab[tabs[0].key][0]]);
  const [isOverlayMode, setIsOverlayMode] = useState(false);

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
    const firstLayer = layersByTab[tabKey][0];
    setActiveLayer(firstLayer);
    // Afficher automatiquement la première couche de l'onglet
    setVisibleLayers([firstLayer]);
    // Désactiver le mode superposition lors du changement d'onglet
    setIsOverlayMode(false);
  };

  const handleLayerNavigation = (direction) => {
    const currentLayers = layersByTab[activeTab];
    const currentIndex = currentLayers.indexOf(activeLayer);
    let newIndex;
    
    if (direction === 'prev') {
      newIndex = currentIndex > 0 ? currentIndex - 1 : currentLayers.length - 1;
    } else {
      newIndex = currentIndex < currentLayers.length - 1 ? currentIndex + 1 : 0;
    }
    
    const newLayer = currentLayers[newIndex];
    setActiveLayer(newLayer);
    
    if (isOverlayMode) {
      // En mode superposition : ajouter la couche aux couches visibles
      if (!visibleLayers.includes(newLayer)) {
        setVisibleLayers([...visibleLayers, newLayer]);
      }
    } else {
      // Mode normal : remplacer la couche visible
      setVisibleLayers([newLayer]);
    }
  };

  const toggleOverlayMode = () => {
    setIsOverlayMode(!isOverlayMode);
    if (isOverlayMode) {
      // Si on désactive le mode superposition, garder seulement la couche active
      setVisibleLayers([activeLayer]);
    }
  };

  const removeLayer = (layerToRemove) => {
    if (visibleLayers.length > 1) {
      const newVisibleLayers = visibleLayers.filter(layer => layer !== layerToRemove);
      setVisibleLayers(newVisibleLayers);
      // Si on supprime la couche active, choisir la première restante
      if (layerToRemove === activeLayer && newVisibleLayers.length > 0) {
        setActiveLayer(newVisibleLayers[0]);
      }
    }
  };

  const legendType = getLegendTypeForLayers(visibleLayers, activeTab);

  return (
    <div
      className="container"
      style={{
        background: "#192c22ff",
        paddingTop: "1em",
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "1em",
          marginTop: "0.25em",
          position: "relative",
          width: "100%",
          marginBottom: "0.75em",
          flex: "0 0 auto"
        }}
      >
        <div style={{ display: "flex", justifyContent: "center", gap: "1em", flex: 1 }}>
          {tabs.map(tab => (
            <button
              key={tab.key}
              className={activeTab === tab.key ? "active" : ""}
              onClick={() => handleTabChange(tab.key)}
              style={{
                fontWeight: "bold",
                fontSize: "0.95em",
                padding: "0.45em 1.1em",
                borderRadius: "6px",
                border: "none",
                background: activeTab === tab.key ? "#a3b18a" : "#7a7c76",
                color: activeTab === tab.key ? "#232b21" : "#fff",
                cursor: "pointer",
                transition: "transform 0.18s, box-shadow 0.18s",
                boxShadow: "0 2px 8px #232b2133",
                margin: 0
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <button
          onClick={() => onNavigate("accueil")}
          style={{
            position: "absolute",
            right: "2em",
            top: 0,
            background: "#a3b18a",
            color: "#232b21",
            border: "none",
            borderRadius: "1.2em",
            padding: "0.45em 1.1em",
            fontWeight: "bold",
            fontSize: "0.95em",
            boxShadow: "0 2px 8px #232b2133",
            cursor: "pointer",
            transition: "transform 0.18s, box-shadow 0.18s"
          }}
          onMouseOver={e => {
            e.currentTarget.style.transform = "scale(1.06)";
            e.currentTarget.style.boxShadow = "0 6px 24px #a3b18a88";
          }}
          onMouseOut={e => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.boxShadow = "0 2px 8px #232b2133";
          }}
        >
          Accueil
        </button>
      </div>

      {/* Navigation entre les couches */}
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "1em",
        marginBottom: "0.5em",
        background: "rgba(44, 57, 41, 0.8)",
        padding: "0.7em",
        borderRadius: "8px",
        marginTop: "0.5em",
        flex: "0 0 auto"
      }}>
        <button
          onClick={() => handleLayerNavigation('prev')}
          style={{
            background: "#7a7c76",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            padding: "0.5em 1em",
            cursor: "pointer",
            fontSize: "0.9em"
          }}
        >
          ← Couche précédente
        </button>
        
        <div style={{
          color: "#a3b18a",
          fontWeight: "bold",
          fontSize: "0.9em",
          textAlign: "center",
          minWidth: "300px"
        }}>
          {activeLayer ? activeLayer.split(':')[1] || activeLayer : 'Aucune couche'}
          <br />
          <span style={{ fontSize: "0.75em", color: "#ccc" }}>
            ({layersByTab[activeTab]?.indexOf(activeLayer) + 1} / {layersByTab[activeTab]?.length})
          </span>
        </div>
        
        <button
          onClick={() => handleLayerNavigation('next')}
          style={{
            background: "#7a7c76",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            padding: "0.5em 1em",
            cursor: "pointer",
            fontSize: "0.9em"
          }}
        >
          Couche suivante →
        </button>

        {/* Bouton Mode Superposition */}
        <button
          onClick={toggleOverlayMode}
          style={{
            background: isOverlayMode ? "#a3b18a" : "#7a7c76",
            color: isOverlayMode ? "#232b21" : "#fff",
            border: "none",
            borderRadius: "6px",
            padding: "0.5em 1em",
            cursor: "pointer",
            fontSize: "0.9em",
            fontWeight: "bold",
            marginLeft: "1em",
            boxShadow: isOverlayMode ? "0 0 10px rgba(163, 177, 138, 0.5)" : "none"
          }}
        >
          {isOverlayMode ? "🔄 Superposition ON" : "🔄 Superposition OFF"}
        </button>
      </div>

      {/* Affichage des couches actives */}
      {visibleLayers.length > 1 && (
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "0.5em",
          marginBottom: "1em",
          background: "rgba(60, 70, 50, 0.9)",
          padding: "0.8em",
          borderRadius: "8px",
          flexWrap: "wrap"
        }}>
          <span style={{ 
            color: "#a3b18a", 
            fontSize: "0.85em", 
            fontWeight: "bold",
            marginRight: "0.5em"
          }}>
            Couches actives ({visibleLayers.length}):
          </span>
          {visibleLayers.map((layer, index) => (
            <div key={layer} style={{
              display: "flex",
              alignItems: "center",
              background: layer === activeLayer ? "#a3b18a" : "#6b705c",
              color: layer === activeLayer ? "#232b21" : "#fff",
              padding: "0.3em 0.6em",
              borderRadius: "4px",
              fontSize: "0.75em",
              gap: "0.5em"
            }}>
              <span>
                {layer.split(':')[1] || layer}
                {layer === activeLayer && " (active)"}
              </span>
              {visibleLayers.length > 1 && (
                <button
                  onClick={() => removeLayer(layer)}
                  style={{
                    background: "transparent",
                    border: "none",
                    color: layer === activeLayer ? "#232b21" : "#fff",
                    cursor: "pointer",
                    fontSize: "1em",
                    padding: 0,
                    lineHeight: 1
                  }}
                  title="Supprimer cette couche"
                >
                  ×
                </button>
              )}
            </div>
          ))}
        </div>
      )}

      <div className="main-content" style={{ display: "flex", flexDirection: "column", flex: "1 1 auto", minHeight: 0 }}>
        {/* Carte en pleine largeur */}
        <div className="map-panel" style={{ width: "100%", flex: "1 1 auto", minHeight: 0 }}>
          <MapView activeLayer={activeLayer} visibleLayers={visibleLayers} />
        </div>
        
        {/* Barre de légende horizontale selon le type */}
        {legendType === "BDPPPA" && <LegendBDPPPAHorizontal />}
        {legendType === "IAC" && <LegendIACHorizontal />}
        {legendType === "SIIGSOL" && <LegendSIIGSOLHorizontal activeLayer={activeLayer} />}
      </div>
    </div>
  );
}